<template>
  <div
    id="advancesettingswrapperdiv"
    :class="$style['adl-advance-filter-content']"
  >
    <h4>{{ contentInfo.heading }}</h4>

    <div :class="$style['cf-supportingText']">{{ contentInfo.subHeading }}</div>

    <div
      class="right-body-container right-body-white-container chart-container"
      :class="$style['cf-chart-rendering']"
      v-if="!isNotShowGraph"
    >
      <div :class="$style['graph-selection-view']"></div>
      <chart-selection
        :chartTabContent="ChartContent"
        @onSelectedTab="onSelectedTab"
      >
        <template v-slot:tabBody>
          <component
            v-if="chartData.length > 0"
            :is="selectedComponent"
            :chartProperties="chartProperties"
            :linePlotData="linePlotData"
            :chartData="chartData"
            :TableSettings="tableViewSettings"
            :ShowTableView="showTableView"
          ></component>
        </template>
      </chart-selection>
    </div>
    <div :style="editableRowStyle">
      <adl-editable-row
        v-if="rowsbaseline"
        :title="baselineTitle"
        :headers="headerbaseline"
        :rows="rowsbaseline"
        @editableRowButtonClick="editableRowButtonClick"
      ></adl-editable-row>
    </div>
    <div>
      <adl-grid
        :addButtonText="addButtonText"
        :updateButtonText="updateButtonText"
        :headers="headers"
        :rows="rows"
        :infoText="infoText"
        :singleHeading="singleHeading"
        :singleHeadingOptions="singleHeadingOptions"
        :singleHeadingButtonText="singleHeadingButtonText"
        :gridSplitId="gridSplitId"
        :isShowHint="isShowHint"
        :focusElementName="focusElementName"
        :gridButtonTemplate="gridButtonTemplate"
        @addRow="addRow"
        @GridSelectionChange="GridSelectionChange"
        :infoError="infoError"
        @editableRowButtonClick="editableRowButtonClick"
        :rowTemplateButton="rowTemplateButton"
        @reset="reset"
        @onChange="onChange"
        @rowTemplateButtonClick="rowTemplateButtonClick"
        :rowOuterButton="rowOuterButton"
        @OuterRowButtonClick="OuterRowButtonClick"
        :emptyGridData="emptyGridData"
        @removeRow="removeRow"
      >
      </adl-grid>
    </div>
  </div>
</template>
<script>
import { ChartSelection } from "../tool";
import AdlGrid from "./grid.vue";
import ChartArea from "./chart-area.vue";
import ChartBar from "./chart-bar.vue";
import ChartTimeSeries from "./chart-time-series.vue";
import AdlEditableRow from "../custom/editable-row/EditableRow.vue";
import { MdsButton } from "@mds/button";
import MdsIcon from "@mds/icon";
export default {
  props: {
    emptyGridData: {
      type: Object,
    },
    rowOuterButton: {
      type: Array,
    },
    contentInfo: {
      type: Object,
    },
    chartProperties: {
      type: Object,
    },
    chartData: {
      type: Array,
    },
    selectedComponent: {
      type: String,
    },
    gridButtonTemplate: {
      type: Array,
    },
    rowTemplateButton: {
      type: Array,
    },

    headerbaseline: {
      type: Array,
    },
    rowsbaseline: {
      type: Array,
    },
    baselineTitle: {
      type: String,
    },

    linePlotData: {
      type: Array,
    },
    addButtonText: {
      type: String,
    },
    updateButtonText: {
      type: String,
    },
    infoText: {
      type: Array,
    },
    infoError: {
      type: Boolean,
    },
    headers: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    singleHeading: {
      type: String,
    },
    singleHeadingOptions: {
      type: Array,
    },
    singleHeadingButtonText: {
      type: String,
    },
    gridSplitId: {
      type: String,
    },
    isShowHint: {
      type: Boolean,
    },
    emptyChartMessage: {
      type: Object,
    },
    focusElementName: {
      type: String,
    },
    editableRowStyle: {
      type: Object,
    },
    isNotShowGraph: {
      type: Boolean,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    tableViewSettings: {
      type: Object,
    },
    buttonDataTypeConfig: {
      type: Array,
    },
    buttonViewTypeConfig: {
      type: Array,
    },
  },
  data() {
    return {
      showAlert: this.contentInfo.infoAlert,
    };
  },
  components: {
    ChartSelection,
    ChartArea,
    ChartBar,
    ChartTimeSeries,
    AdlEditableRow,
    AdlGrid,
    MdsButton,
    MdsIcon,
  },
  computed: {
    ChartContent() {
      return this.contentInfo.chartTabContent;
      // if (this.showTableView) {
      //   return this.contentInfo.chartTabContentTable;
      // } else {
      //   return this.contentInfo.chartTabContent;
      // }
    },
  },

  async created() {},
  methods: {
    onSelectDataTypeFilter(button, item, filterType) {
      this.$emit("onSelectDataTypeFilter", button, item, filterType);
    },

    onSelectViewTypeFilter(button, item, filterType) {
      this.$emit("onSelectViewTypeFilter", button, item, filterType);
    },
    dropDownChange(callBackMethod, data) {
      this.$emit("dropDownChange", callBackMethod, data);
    },
    OuterRowButtonClick(callBackMethod, data) {
      this.$emit("OuterRowButtonClick", callBackMethod, data);
    },
    closeAlert() {
      this.showAlert = false;
      this.$emit("closeAlert");
    },
    addRow(index, subtypeid) {
      this.$emit("addRow", index, subtypeid);
    },
    removeRow(data) {
      this.$emit("removeRow", data);
    },

    GridSelectionChange(data) {
      this.$emit("GridSelectionChange", data);
    },
    setFocusOnGridRow() {
      this.$emit("setFocusOnRowElement");
    },
    editableRowButtonClick(callBackMethod, data, rowindex) {
      this.$emit("editableRowButtonClick", callBackMethod, data, rowindex);
    },
    rowTemplateButtonClick(callBackMethod, data, row) {
      this.$emit("rowTemplateButtonClick", callBackMethod, data, row);
    },
    onSelectedTab(tabId) {
      this.$emit("onChangeChartTab", tabId);
    },
    reset(callBackMethod) {
      this.$emit(callBackMethod);
    },
    onChange(ind) {
      this.$emit("onChange", ind);
    },
  },
};
</script>
<style lang="scss" module>
.adl-advance-filter-content {
  height: calc(90vh - 114px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px 4px;
  padding-bottom: 16px;
  .emptychartbox {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0px;
    flex-direction: column;
  }

  .emptychartboxicon {
    // border: 1px solid #ddd;
    /* padding: 30px; */
    // height: 50px;
    // width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .emptychartboxpadding {
    padding: 14px;
    font-size: 24px;
    padding-bottom: 24px;
  }

  .cf-supportingText {
    padding-top: $mds-space-1-x;
    padding-bottom: $mds-space-1-x;
  }

  .cf-chart-rendering {
    margin-top: $mds-space-1-x;
  }
}
.adl-advance-filter-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.adl-advance-filter-content::-webkit-scrollbar-thumb {
  background-color: #c3d0da;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
</style>
